import Logger from "./Logger.js";
import {NetworkError} from "../net/httpClient.js";
//import {logError as doLogError} from "../actions/net.js";
//import {javascriptVersion} from "./config.jsx";

/**
 * Loggar en händelse till api backend.
 * @param {Object} state 
 * @param {string} message 
 * @returns {undefined}
 */
// export function logInfo(state, message){
//     try {
//         //doLogError(javascriptVersion, message, Error().stack, state.authentication.token);
//         console.log(message);
//     } catch (error){
//         //logError(state, error);
//         console.log(message);
//     }
// }


/**
 * Loggar ett fel till api backend.
 * @param {Object} state 
 * @param {Object} error 
 * @returns {undefined}
 */
export function logError(state, error){
    try {
        if (!state.authentication.token) {
            return;
        }
        
        if (error instanceof NetworkError){
            //const {url, errorType, message, stack} = error || {};
            //const text = `NetworkError: url: ${url}, errorType: ${errorType}, message: ${message}`;
            //doLogError(javascriptVersion, text, stack, state.authentication.token);
            if (process.env.NODE_ENV !== "production") {
                Logger.error(error);//alert(error);
            }
        } else {
            //const {message, stack} = error || {};
            //doLogError(javascriptVersion, message || "Unknown error message", stack || `Unknown callstack, caught: ${Error().stack}`, state.authentication.token);
            if (process.env.NODE_ENV !== "production") {
                Logger.error(error);//alert(error);
            }
        }

    } catch (error) {
        // Vad göra här?
        Logger.error(error);//alert(error);
    }
}